import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import type { ShareResult } from '@/utils/share';

const MESSAGES: Record<ShareResult, string> = {
  shared: 'Podijeljeno!',
  copied: 'Kopirano u međuspremnik',
  failed: 'Greška pri dijeljenju',
};

interface ShareToastProps {
  result: ShareResult | null;
  onDismiss: () => void;
}

export const ShareToast: React.FC<ShareToastProps> = ({ result, onDismiss }) => {
  useEffect(() => {
    if (!result) return;
    const t = setTimeout(onDismiss, 2500);
    return () => clearTimeout(t);
  }, [result, onDismiss]);

  return (
    <AnimatePresence>
      {result && (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 10 }}
          className="fixed bottom-24 left-4 right-4 z-[60] mx-auto max-w-sm"
        >
          <div
            className={`rounded-xl px-4 py-3 text-center text-sm font-medium ${
              result === 'failed'
                ? 'bg-red-500/90 text-white'
                : 'glass text-white'
            }`}
          >
            {MESSAGES[result]}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
